module.exports = __webpack_public_path__ + "img/paySuccess.b775ef10.png";